import { render } from "./VtoPageCompare.vue?vue&type=template&id=33e3dfd5"
import script from "./VtoPageCompare.vue?vue&type=script&lang=js"
export * from "./VtoPageCompare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__